export function useYandexPay() {
  const { yandexPayMerchantId } = useRuntimeConfig().public;

  async function createYandexPaySession(amount?: number): Promise<WtfishYandexPaySession | null> {
    if (import.meta.server) return null;

    const yaPay = window.YaPay;
    const totalAmount = amount ?? useCartStore().cart.calculate.total + useCheckoutStore().deliveryCost;

    if (!yaPay || !yandexPayMerchantId || !Number.isFinite(totalAmount) || totalAmount <= 0) return null;

    const paymentData = {
      availablePaymentMethods: ['SPLIT'],
      currencyCode: yaPay.CurrencyCode.Rub,
      totalAmount: totalAmount.toFixed(2),
      version: 4,
      merchantId: yandexPayMerchantId,
    };

    const onPayButtonClick = () => {};

    try {
      const paymentSession = await yaPay.createSession(paymentData, { onPayButtonClick });

      return paymentSession ?? null;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  return { createYandexPaySession };
}
